export default "__VITE_ASSET__516a9988__"